var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38296",
    "data-name": "Group 38296",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7666",
    "data-name": "Rectangle 7666",
    width: 31,
    height: 31,
    rx: 5,
    fill: "#c7b9eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assessment",
    transform: "translate(8.81 8.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M34.88,73.193l-.2.205a.122.122,0,1,0,.177.169l.2-.205a17.387,17.387,0,0,0,1.749-.391l-1.6-1.539a17.388,17.388,0,0,0-.328,1.761Z",
    transform: "translate(-30.605 -60.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M42.03,35.576l6.292-6.52a.535.535,0,0,0-.014-.757l-.824-.8a.535.535,0,0,0-.757.014l-6.293,6.52Zm5.21-6.657.288.278-5.456,5.657-.288-.278Zm-.34-.328-5.457,5.655-.288-.278,5.457-5.655Z",
    transform: "translate(-35.464 -23.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M59.967,19.376h.84v1.968l.816-.846v-1.53a.408.408,0,0,0-.408-.407H59.919a1.749,1.749,0,0,1,.075.513A1.716,1.716,0,0,1,59.967,19.376Z",
    transform: "translate(-51.824 -16.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M24.733,8.839H27.67a1.16,1.16,0,1,0,0-2.32h-.257a1.246,1.246,0,1,0-2.427,0h-.255a1.16,1.16,0,0,0,0,2.32ZM26.2,5.555a.684.684,0,1,1-.684.684.684.684,0,0,1,.684-.684Z",
    transform: "translate(-21.304 -4.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M9.814,30.808h8.979A.408.408,0,0,0,19.2,30.4V26l-.816.847v3.145H10.22V19.376h.84a1.717,1.717,0,0,1-.026-.3,1.749,1.749,0,0,1,.075-.513H9.814a.408.408,0,0,0-.408.407V30.4a.408.408,0,0,0,.408.408Z",
    transform: "translate(-9.406 -16.386)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.031d3a85d8b5b547b2e6233dd1a4662d.svg";
export { ForwardRef as ReactComponent };